'use client';

import { c as _c } from "react/compiler-runtime";
import { useId, useState } from 'react';
import { SharedAnimatedValue } from '@/app/lcv/components/sections/spartan/shared/animated-value';
import type { SpartanLineupModelCardEngineDetailsProps } from '@/app/lcv/components/sections/spartan/shared/lineup/carousel/model-card/engine-details/types';
import { getSpartanLineupEngineIndicatorKind, getSpartanLineupEngineIndicatorTone, getSpartanLineupEngineTabsVariant } from '@/app/lcv/components/sections/spartan/shared/lineup/carousel/model-card/styles';
import { SPARTAN_LINEUP_ENGINE_SPEC_UNITS, SPARTAN_LINEUP_LABELS } from '@/app/lcv/components/sections/spartan/shared/lineup/constants';
import { SPARTAN_LINEUP_DATA_GA, SPARTAN_LINEUP_TRACKING } from '@/app/lcv/components/sections/spartan/shared/lineup/tracking';
import { SpartanTabs } from '@/app/lcv/components/sections/spartan/shared/tabs';
import { cn } from '@/app/utils/cn';
import { createDataAttributes } from '@/app/utils/createDataAttributes';
import { stripHtmlTags } from '@/app/utils/format';
export const SpartanLineupModelCardEngineDetails = t0 => {
  const $ = _c(93);
  const {
    engines,
    modelTitle,
    selectedEngine,
    selectedIndex,
    modelIndex,
    eventName,
    isDark,
    styleName,
    engineTabsTitle: t1,
    engineRemark,
    onSelectEngine
  } = t0;
  const engineTabsTitle = t1 === undefined ? SPARTAN_LINEUP_LABELS.engineTabsTitle : t1;
  const tabGroupId = useId();
  const panelId = `${tabGroupId}-panel`;
  const selectedTabId = `${tabGroupId}-tab-${selectedIndex + 1}`;
  const [settledIndex, setSettledIndex] = useState(selectedIndex);
  const [animateSpecOnEnter, setAnimateSpecOnEnter] = useState(false);
  if (selectedIndex !== settledIndex) {
    setSettledIndex(selectedIndex);
    setAnimateSpecOnEnter(true);
  }
  let t2;
  if ($[0] !== modelIndex) {
    t2 = createDataAttributes({
      test: SPARTAN_LINEUP_TRACKING.modelEngine(modelIndex)
    });
    $[0] = modelIndex;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = isDark ? "text-white" : "text-gray-900";
  let t4;
  if ($[2] !== t3) {
    t4 = cn("text-body-1 font-noto-bold", t3);
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== engineTabsTitle) {
    t5 = {
      __html: engineTabsTitle
    };
    $[4] = engineTabsTitle;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== modelIndex) {
    t6 = createDataAttributes({
      test: SPARTAN_LINEUP_TRACKING.modelEngineTitle(modelIndex)
    });
    $[6] = modelIndex;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t4 || $[9] !== t5 || $[10] !== t6) {
    t7 = <p className={t4} dangerouslySetInnerHTML={t5} {...t6} />;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  const t8 = isDark ? "dark" : "light";
  let t9;
  if ($[12] !== styleName || $[13] !== t8) {
    t9 = getSpartanLineupEngineTabsVariant({
      tone: t8,
      styleName
    });
    $[12] = styleName;
    $[13] = t8;
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  const t10 = isDark ? "dark" : "light";
  let t11;
  if ($[15] !== modelTitle || $[16] !== selectedEngine.engineKey || $[17] !== styleName || $[18] !== t10) {
    t11 = getSpartanLineupEngineIndicatorKind({
      tone: t10,
      styleName,
      engineKey: selectedEngine.engineKey,
      modelTitle
    });
    $[15] = modelTitle;
    $[16] = selectedEngine.engineKey;
    $[17] = styleName;
    $[18] = t10;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  const t12 = isDark ? "dark" : "light";
  let t13;
  if ($[20] !== modelTitle || $[21] !== selectedEngine.engineKey || $[22] !== styleName || $[23] !== t12) {
    t13 = getSpartanLineupEngineIndicatorTone({
      tone: t12,
      styleName,
      engineKey: selectedEngine.engineKey,
      modelTitle
    });
    $[20] = modelTitle;
    $[21] = selectedEngine.engineKey;
    $[22] = styleName;
    $[23] = t12;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  let t14;
  if ($[25] !== modelTitle) {
    t14 = stripHtmlTags(modelTitle);
    $[25] = modelTitle;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] !== engineTabsTitle) {
    t15 = stripHtmlTags(engineTabsTitle);
    $[27] = engineTabsTitle;
    $[28] = t15;
  } else {
    t15 = $[28];
  }
  const t16 = `${t14} ${t15}`;
  const t17 = String(selectedIndex);
  let t18;
  if ($[29] !== engines || $[30] !== panelId || $[31] !== tabGroupId) {
    let t19;
    if ($[33] !== panelId || $[34] !== tabGroupId) {
      t19 = (engine, index) => ({
        label: engine.label,
        value: String(index),
        tabId: `${tabGroupId}-tab-${index + 1}`,
        panelId
      });
      $[33] = panelId;
      $[34] = tabGroupId;
      $[35] = t19;
    } else {
      t19 = $[35];
    }
    t18 = engines.map(t19);
    $[29] = engines;
    $[30] = panelId;
    $[31] = tabGroupId;
    $[32] = t18;
  } else {
    t18 = $[32];
  }
  let t19;
  if ($[36] !== modelIndex) {
    t19 = SPARTAN_LINEUP_TRACKING.modelEngineTabItem(modelIndex);
    $[36] = modelIndex;
    $[37] = t19;
  } else {
    t19 = $[37];
  }
  let t20;
  if ($[38] !== eventName) {
    t20 = {
      eventName,
      group: SPARTAN_LINEUP_DATA_GA.section
    };
    $[38] = eventName;
    $[39] = t20;
  } else {
    t20 = $[39];
  }
  let t21;
  if ($[40] !== modelIndex) {
    t21 = createDataAttributes({
      test: SPARTAN_LINEUP_TRACKING.modelEngineTabs(modelIndex)
    });
    $[40] = modelIndex;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== onSelectEngine || $[43] !== t11 || $[44] !== t13 || $[45] !== t16 || $[46] !== t17 || $[47] !== t18 || $[48] !== t19 || $[49] !== t20 || $[50] !== t21 || $[51] !== t9) {
    t22 = <SpartanTabs variant={t9} indicatorKind={t11} indicatorTone={t13} hideWhenSingle={false} aria-label={t16} className="mt-2" value={t17} onChange={onSelectEngine} items={t18} itemTestIdPrefix={t19} tracking={t20} {...t21} />;
    $[42] = onSelectEngine;
    $[43] = t11;
    $[44] = t13;
    $[45] = t16;
    $[46] = t17;
    $[47] = t18;
    $[48] = t19;
    $[49] = t20;
    $[50] = t21;
    $[51] = t9;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== modelIndex) {
    t23 = createDataAttributes({
      test: SPARTAN_LINEUP_TRACKING.modelEnginePanel(modelIndex)
    });
    $[53] = modelIndex;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  let t24;
  if ($[55] !== modelIndex) {
    t24 = createDataAttributes({
      test: SPARTAN_LINEUP_TRACKING.modelEngineSpecList(modelIndex)
    });
    $[55] = modelIndex;
    $[56] = t24;
  } else {
    t24 = $[56];
  }
  let t25;
  if ($[57] !== animateSpecOnEnter || $[58] !== isDark || $[59] !== modelIndex || $[60] !== selectedEngine.specs || $[61] !== selectedIndex) {
    let t26;
    if ($[63] !== animateSpecOnEnter || $[64] !== isDark || $[65] !== modelIndex || $[66] !== selectedIndex) {
      t26 = (spec, specIndex) => <li key={[spec.label, specIndex].join("-")} className="xs:p-2 px-0 py-2" {...createDataAttributes({
        test: SPARTAN_LINEUP_TRACKING.modelEngineSpec(modelIndex, specIndex)
      })}><p className={cn("text-body-2-fixed [&_sup]:top-[-0.4em] [&_sup]:text-[70%]", isDark ? "text-gray-200" : "text-gray-600")} dangerouslySetInnerHTML={{
          __html: spec.label
        }} {...createDataAttributes({
          test: SPARTAN_LINEUP_TRACKING.modelEngineSpecLabel(modelIndex, specIndex)
        })} /><p className={cn("text-body-1 font-noto-bold", isDark ? "text-white" : "text-gray-900")}><SharedAnimatedValue key={[selectedIndex, spec.value].join("-")} value={spec.value} animateOnEnter={animateSpecOnEnter} direction={spec.unit === SPARTAN_LINEUP_ENGINE_SPEC_UNITS.fuelEconomy ? "horizontal" : "auto"} {...createDataAttributes({
            test: SPARTAN_LINEUP_TRACKING.modelEngineSpecValue(modelIndex, specIndex)
          })} />{" "}<span {...createDataAttributes({
            test: SPARTAN_LINEUP_TRACKING.modelEngineSpecUnit(modelIndex, specIndex)
          })}>{spec.unit}</span></p></li>;
      $[63] = animateSpecOnEnter;
      $[64] = isDark;
      $[65] = modelIndex;
      $[66] = selectedIndex;
      $[67] = t26;
    } else {
      t26 = $[67];
    }
    t25 = selectedEngine.specs.map(t26);
    $[57] = animateSpecOnEnter;
    $[58] = isDark;
    $[59] = modelIndex;
    $[60] = selectedEngine.specs;
    $[61] = selectedIndex;
    $[62] = t25;
  } else {
    t25 = $[62];
  }
  let t26;
  if ($[68] !== t24 || $[69] !== t25) {
    t26 = <ul className="xs:gap-1 xs:px-0 grid grid-cols-3 px-2" {...t24}>{t25}</ul>;
    $[68] = t24;
    $[69] = t25;
    $[70] = t26;
  } else {
    t26 = $[70];
  }
  const t27 = engineRemark ? undefined : true;
  const t28 = isDark ? "text-gray-200" : "text-gray-600";
  const t29 = !engineRemark && "invisible";
  let t30;
  if ($[71] !== t28 || $[72] !== t29) {
    t30 = cn("text-caption where-small:text-body-2-fixed px-2", t28, t29);
    $[71] = t28;
    $[72] = t29;
    $[73] = t30;
  } else {
    t30 = $[73];
  }
  let t31;
  if ($[74] !== engineRemark || $[75] !== modelIndex) {
    t31 = engineRemark ? createDataAttributes({
      test: SPARTAN_LINEUP_TRACKING.modelEngineRemark(modelIndex)
    }) : {};
    $[74] = engineRemark;
    $[75] = modelIndex;
    $[76] = t31;
  } else {
    t31 = $[76];
  }
  const t32 = engineRemark || "\xA0";
  let t33;
  if ($[77] !== t27 || $[78] !== t30 || $[79] !== t31 || $[80] !== t32) {
    t33 = <p aria-hidden={t27} className={t30} data-spartan-lineup-engine-remark-slot="" {...t31}>{t32}</p>;
    $[77] = t27;
    $[78] = t30;
    $[79] = t31;
    $[80] = t32;
    $[81] = t33;
  } else {
    t33 = $[81];
  }
  let t34;
  if ($[82] !== panelId || $[83] !== selectedTabId || $[84] !== t23 || $[85] !== t26 || $[86] !== t33) {
    t34 = <div id={panelId} role="tabpanel" aria-labelledby={selectedTabId} className="py-2" {...t23}>{t26}{t33}</div>;
    $[82] = panelId;
    $[83] = selectedTabId;
    $[84] = t23;
    $[85] = t26;
    $[86] = t33;
    $[87] = t34;
  } else {
    t34 = $[87];
  }
  let t35;
  if ($[88] !== t2 || $[89] !== t22 || $[90] !== t34 || $[91] !== t7) {
    t35 = <div className="mt-2" {...t2}>{t7}{t22}{t34}</div>;
    $[88] = t2;
    $[89] = t22;
    $[90] = t34;
    $[91] = t7;
    $[92] = t35;
  } else {
    t35 = $[92];
  }
  return t35;
};